import React, { useState, useRef,useEffect, useLayoutEffect } from "react";
import { Link , useLocation} from "react-router-dom";
import { DatePicker } from "antd";
import PredefinedDateRanges from "../../core/common/datePicker";
import { useHeaderFilters } from "../../context/HeaderFilterContext";
import CommonSelect from "../../core/common/commonSelect";
import type { Option } from "../../core/common/commonSelect";
import api from "../../api";
import { useParams, useNavigate } from "react-router-dom";
import { encryptQuery, decryptQuery } from "../../utils/encryption";
import Table from "../../core/common/dataTable/index";
import useDynamicPageSize from "../../useDynamicPageSize";
import Footer from "../../Footer";
import "bootstrap/dist/js/bootstrap.bundle.min";
import dayjs from "dayjs";
import moment from "moment";
import { useSelector } from "react-redux";
import { useFilterData } from "../../context/FilterContext";
import { useIsMobile } from "../../hooks/useIsMobile";
import { toast, ToastContainer } from "react-toastify";


const AttendanceList = () => {
  const isMobile = useIsMobile(991);
  const latestRequestIdRef = useRef(0);

  const { setFilters } = useHeaderFilters();
  const navigate = useNavigate();
  const { encryptedQuery } = useParams<{
    moduleName: string;
    encryptedQuery?: string;
  }>();
  const { filtersData } = useFilterData();
  console.log("filtersData in dropdown component:", filtersData);

  const dataLayout = useSelector((state: any) => state.themeSetting.dataLayout);
  const expandedWidth = 40;
  const collapsedWidth = 72;
  const sidebarWidth =
    dataLayout === "mini_layout" ? collapsedWidth : expandedWidth;

  const [currentPage, setCurrentPage] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const pageSize = useDynamicPageSize();
  const [tableHeight, setTableHeight] = useState<number>(0);


   useLayoutEffect(() => {
          if (pageSize === 0) return;
    const calculateHeight = () => {
      const baseOffset = 285;
      const extraOffset = window.innerWidth <= 991 ? -60 : -80;
      const fixedOffset = baseOffset + extraOffset;

      const newHeight = window.innerHeight - fixedOffset;

      console.log("Calculated table height:", newHeight);
      console.log("fixedOffset:", fixedOffset);
      console.log("window.innerHeight:", window.innerHeight);
      console.log("pageSize:", pageSize);
      console.log("totalItems:", totalItems);

      setTableHeight(newHeight);
    };

    calculateHeight(); // initial + on totalItems change
    window.addEventListener("resize", calculateHeight);

    return () => window.removeEventListener("resize", calculateHeight);
  }, [totalItems, pageSize]);

  const [users, setUsers] = useState<Option[]>([]);
  const [isReportingHead, setIsReportingHead] = useState(false);
  const [userRole, setUserRole] = useState<number | null>(null);
  const [loggedInUserId, setLoggedInUserId] = useState<string | null>(null);
  const [selectedUserId, setSelectedUserId] = useState<string | null>("all");
  const [attendanceRecords, setAttendanceRecords] = useState<any[]>([]);
  const [TodayHours, setTodayHours] = useState("0");
  const [TotalUnverifiedrecord, setTotalUnverifiedrecord] = useState<
    number | null
  >(0);
  const [errorCount, setErrorCount] = useState<number | null>(0);
  const [TotalMinute, setTotalMinute] = useState("0");
  const [TotalBreakminute, setTotalBreakminute] = useState("0");
  const [attendanceErrorMessage, setAttendanceErrorMessage] = useState("");
  const [isLOPChecked, setIsLOPChecked] = useState(false);
  const [isVerifiedChecked, setIsVerifiedChecked] = useState(false);
  const [loading, setLoading] = useState(true);
  const [expandedRows, setExpandedRows] = useState<{ [key: string]: boolean }>(
    {}
  );
  const today = new Date().toISOString().split("T")[0];
  const [selectedStartDate, setSelectedStartDate] = useState<string>(today);
  const [selectedEndDate, setSelectedEndDate] = useState<string>(today);
  const [editingRowId, setEditingRowId] = useState<number | null>(null);
  const [editingValue, setEditingValue] = useState<string>("");
  const [selectedEmployee, setSelectedEmployee] = useState<number | null>(null);
  const [punchDate, setPunchDate] = useState(dayjs());
  const [attendanceHistory, setAttendanceHistory] = useState<any[]>([]);
  const [selectedDate, setSelectedDate] = useState(dayjs());
  const [selectedEmployeeId, setSelectedEmployeeId] = useState<number>(0);
  const [selectIsVerified, setSelectIsVerified] = useState<boolean>(false);
  const [employees, setEmployees] = useState<Employee[]>([]);
  const modalRef = useRef<HTMLDivElement | null>(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [hour, setHour] = useState("12");
  const [minute, setMinute] = useState("00");
  const [second, setSecond] = useState("00");
  const [ampm, setAMPM] = useState("AM");
  const [time, setTime] = useState("12:00:00 AM");
  const [showDeleteConfirmModal, setShowDeleteConfirmModal] = useState(false);
  const [selectedIsDeleted, setSelectedIsDeleted] = useState<boolean>(false);
  const [selectedIsVerified, setSelectedIsVerified] = useState<boolean>(true);
  const inputRef = useRef<HTMLInputElement | null>(null);
  const isSavingRef = useRef(false);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [isLoadingHistory, setIsLoadingHistory] = useState(false);
  const [isMobileView, setIsMobile] = useState(false);

  const defaultFilterValues: AttendanceFilterParams = {
    selectedUserId: "all",
    isLOPChecked: false,
    isVerifiedChecked: false,
    selectedStartDate: today,
    selectedEndDate: today,
    currentPage: 1,
    attendanceErrorMessage: "",
  };

  const areFiltersDefault = (filters: AttendanceFilterParams) => {
    return (
      filters.selectedUserId === "all" &&
      filters.isLOPChecked === defaultFilterValues.isLOPChecked &&
      filters.isVerifiedChecked === defaultFilterValues.isVerifiedChecked &&
      filters.selectedStartDate === defaultFilterValues.selectedStartDate &&
      filters.selectedEndDate === defaultFilterValues.selectedEndDate &&
      (filters.currentPage ?? 1) === defaultFilterValues.currentPage &&
      (filters.attendanceErrorMessage ?? "") ===
        defaultFilterValues.attendanceErrorMessage
    );
  };

  useEffect(() => {
    document.body.classList.add("custom-table-padding");

    return () => {
      document.body.classList.remove("custom-table-padding");
    };
  }, []);

  useEffect(() => {
    console.log("pageSize for attendance:", pageSize);
  }, []);

  const formatDate = (date: string) => {
    if (!date) return ""; // Handle undefined/null dates
    return new Date(date).toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  const formatAttTime = (timeString: string) => {
    if (!timeString) return ""; // Handle empty/null values
    const [hours, minutes, seconds] = timeString.split(":").map(Number);
    const period = hours >= 12 ? "PM" : "AM";
    const formattedHours = hours % 12 || 12;
    return `${formattedHours}:${String(minutes).padStart(2, "0")}:${String(
      seconds
    ).padStart(2, "0")} ${period}`;
  };

  // Helper function to format time
  const formatTime = (value: number) => value.toString().padStart(2, "0");

  const resetForm = () => {
    setSelectedDate(punchDate);
    setHour("12");
    setMinute("00");
    setSecond("00");
    setAMPM("AM");
  };

  useEffect(() => {
    const modalElement = document.getElementById("timeModal");

    if (modalElement) {
      modalElement.addEventListener("hidden.bs.modal", resetForm);

      // Cleanup event listener when component unmounts
      return () => {
        modalElement.removeEventListener("hidden.bs.modal", resetForm);
      };
    }
  }, []);

  // Handle hour change
  // Allow typing, but clamp to max 12 immediately
const handleHourChange = (e: React.ChangeEvent<HTMLInputElement>) => {
  let value = e.target.value.replace(/\D/g, ""); // only digits

  if (value === "") {
    setHour("");
    return;
  }

  let numValue = parseInt(value, 10);

  if (numValue > 12) {
    numValue = 12; // clamp immediately
  }

  setHour(numValue.toString());
};

// Final cleanup (pad to 2 digits on blur)
const handleHourBlur = () => {
  if (hour === "") return;

  let numValue = parseInt(hour, 10);
  if (isNaN(numValue) || numValue < 1) {
    numValue = 1; // enforce minimum
  }

  setHour(numValue.toString().padStart(2, "0"));
};


  // Handle minute change
  const handleMinuteChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let value = e.target.value;

    if (value === "") {
      setMinute(value);
      return;
    }

    let numValue = parseInt(value, 10);
    if (numValue < 0) {
      numValue = 0;
    } else if (numValue > 59) {
      numValue = 59;
    }

    setMinute(numValue.toString().padStart(2, "0"));
  };

  // Handle second change
  const handleSecondChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let value = e.target.value;

    if (value === "") {
      setSecond(value);
      return;
    }

    let numValue = parseInt(value, 10);
    if (numValue < 0) {
      numValue = 0;
    } else if (numValue > 59) {
      numValue = 59;
    }

    setSecond(numValue.toString().padStart(2, "0"));
  };

  const onSaveHistory = async () => {
    const numHour = hour === "" ? 0 : parseInt(hour, 10);
    const numMinute = minute === "" ? 0 : parseInt(minute, 10);
    const numSecond = second === "" ? 0 : parseInt(second, 10);

    const formattedTime = `${formatTime(numHour)}:${formatTime(
      numMinute
    )}:${formatTime(numSecond)} ${ampm}`;

    setTime(formattedTime);

    const parsedDate = dayjs(punchDate).startOf("day"); // Force to local midnight

    const validDate = parsedDate.isValid() ? parsedDate : dayjs();

    const data = {
      employee_id: selectedEmployee,
      punch_date: validDate.format("YYYY-MM-DD"),
      punch_time: formattedTime,
    };

    try {
      const response: AttendanceApiResponse = await api(
        "/save-attendance-record",
        {
          method: "POST",
          body: data,
        }
      );

      console.log("API Response:", response);

      setSelectedDate(punchDate);
      setHour("12");
      setMinute("0");
      setSecond("0");
      setAMPM("AM");
      setTime("12:00:00 AM");
      setSelectedEmployee(null);

      const closeBtn = document.getElementById(
        "hiddenCloseBtn"
      ) as HTMLButtonElement;
      if (closeBtn) {
        closeBtn.click(); // Simulate a click to trigger data-bs-dismiss
      }

      resetForm();
    } catch (error) {
      console.error("Error during API call:", error);
    }
  };

  // Function to submit the modal data
  const handleSaveClick = async () => {
    await onSaveHistory();
    fetchAttendance();
  };

  const handleCheckboxClick = (id: number, isDeleted: boolean) => {
    console.log("Clicked checkbox for", id, isDeleted);

    setShowDeleteConfirmModal(true);
    setSelectedEmployeeId(id);
    setSelectedIsDeleted(isDeleted);
  };

  const handleDelete = async (employeeId: number, isDeleted: boolean) => {
    console.log(
      "Deleting or restoring employee",
      employeeId,
      "Deleted:",
      isDeleted
    );

    const data = {
      id: employeeId,
      is_deleted: isDeleted ? 1 : 0,
    };

    try {
      const response: AttendanceApiResponse = await api(
        "/update-employee-attendance",
        {
          method: "POST",
          body: data,
        }
      );

      console.log("Success:", response);

      setAttendanceHistory((prev) =>
        prev.map((employee) =>
          employee.id === employeeId
            ? { ...employee, is_deleted: isDeleted ? 1 : 0 }
            : employee
        )
      );

      setShowDeleteConfirmModal(false);
      fetchAttendance();
    } catch (error) {
      console.error("Error updating attendance:", error);
    }
  };

  // Function to handle cancel action
  const handleCancel = () => {
    console.log("Delete action canceled");
    setShowDeleteConfirmModal(false);
  };

  useEffect(() => {
    if (isModalOpen && modalRef.current) {
      const modal = new window.bootstrap.Modal(modalRef.current);
      modal.show();

      modalRef.current.addEventListener("hidden.bs.modal", () => {
        setIsModalOpen(false);
      });
    }
  }, [isModalOpen]);

  console.log("AttendanceList render:", {
    isLOPChecked,
    isVerifiedChecked,
  });

 useEffect(() => {
  if (!selectedUserId || !selectedStartDate || !selectedEndDate) return;

  const handler = setTimeout(() => {
    fetchAttendance();
  }, 300);

  return () => clearTimeout(handler);
}, [
  selectedStartDate,
  selectedEndDate,
  selectedUserId,
  attendanceErrorMessage,
  isLOPChecked,
  isVerifiedChecked,
  currentPage,
  pageSize,
]);

  const handleErrorClick = () => {
    setAttendanceErrorMessage("attendance error");
    setCurrentPage((prev) => {
      console.log("API CALLED ERROR", currentPage, attendanceErrorMessage);
      return prev;
    });

    updateFilterUrl({
      selectedUserId,
      isLOPChecked,
      isVerifiedChecked,
      selectedStartDate,
      selectedEndDate,
      attendanceErrorMessage: "attendance error",
    });
  };

  const handleErrorsClick = () => {
    setAttendanceErrorMessage("error");
    setCurrentPage((prev) => {
      console.log("API CALLED ERROR", currentPage, attendanceErrorMessage);
      return prev;
    });

    updateFilterUrl({
      selectedUserId,
      isLOPChecked,
      isVerifiedChecked,
      selectedStartDate,
      selectedEndDate,
      attendanceErrorMessage: "error",
    });
  };

  const handleRowToggle = (employeeId: string | number) => {
    setExpandedRows((prev) => ({
      ...prev,
      [employeeId]: !prev[employeeId],
    }));
  };

  const expandedRowKeys = Object.entries(expandedRows)
    .filter(([_, expanded]) => expanded)
    .map(([key]) => Number(key));

  const tableOnExpand = (expanded: boolean, record: any) => {
    handleRowToggle(record.id);
  };

  const convertToAMPM = (timeStr: string | undefined) => {
    if (!timeStr) return "-";
    const date = new Date(timeStr);
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const suffix = hours >= 12 ? "PM" : "AM";
    const hour12 = (hours % 12 || 12).toString().padStart(2, "0");
    const minuteStr = minutes.toString().padStart(2, "0");
    return `${hour12}:${minuteStr} ${suffix}`;
  };

  const formatTotalMinutes = (totalMinutes: number | undefined) => {
    if (!totalMinutes) return "-"; // Fallback for undefined values
    if (totalMinutes <= 59) {
      return `${totalMinutes} min${totalMinutes === 1 ? "" : "s"}`;
    } else {
      const hours = Math.floor(totalMinutes / 60);
      const minutes = totalMinutes % 60;
      return minutes > 0
        ? `${hours} hr${hours === 1 ? "" : "s"} ${minutes} min${
            minutes === 1 ? "" : "s"
          }`
        : `${hours} hr${hours === 1 ? "" : "s"}`;
    }
  };

  interface InOutSummary {
    employee_id: number;
    in_time: string;
    out_time: string;
    total_minutes: number;
  }

  const expandIconColumn = {
    title: "",
    dataIndex: "expand",
    minWidth: 30,
    maxWidth: 30,
    render: (_: any, record: any) => {
      const isExpandable = record.in_out_summary?.length > 0;
      const isExpanded = expandedRows[record.id];

      if (!isExpandable) return null;

      return (
        <i
          className={`fas ${isExpanded ? "fa-minus" : "fa-plus"}`}
          onClick={() => tableOnExpand(!isExpanded, record)}
          style={{ cursor: "pointer", color: "#999" }}
          title={isExpanded ? "Close" : "Expand"}
        />
      );
    },
  };

  const serialNumberColumn = {
    title: "#",
    dataIndex: "serialNumber",
    minWidth: 30,
    maxWidth: 30,
    render: (_: any, __: any, index: number) =>
      (currentPage - 1) * pageSize + index + 1,
  };

  const hasExpandableRows = attendanceRecords.some(
    (record) => record.in_out_summary?.length > 0
  );

  const location = useLocation();
  const handleImageClick = (
    employeeId: string | number,
    employeeName: string
  ) => {
    const previousUrl = location.pathname + location.search;
    navigate(`/profile/${employeeId}`, {
      state: {
        from: "attendance",
        employeeName,
        attUrl: previousUrl,
      },
    });
  };

  const enableEditing = (id: number, currentValue: number) => {
    setEditingRowId(id);
    setEditingValue(currentValue.toString());
  };

  // Function to save the updated value
  const handleSaveUpdatedValue = (id: number) => {
    saveUpdatedValue(id);
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        inputRef.current &&
        !inputRef.current.contains(event.target as Node)
      ) {
        handleSaveUpdatedValue(editingRowId as number);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [editingRowId, editingValue]);

  const saveUpdatedValue = async (id: number) => {
    if (isSavingRef.current) return;
    isSavingRef.current = true;

    const updatedValue = editingValue;
    if (isNaN(Number(updatedValue)) || updatedValue === "") {
      isSavingRef.current = false;
      return;
    }

    try {
      const response: AttendanceApiResponse = await api("/update-total-paid", {
        method: "POST",
        body: {
          attendance_id: id,
          total_paid: updatedValue,
        },
      });

      setEmployees((prev) =>
        prev.map((emp: any) =>
          emp.id === id ? { ...emp, total_paid_override: updatedValue } : emp
        )
      );

      setEditingRowId(null);
      setEditingValue("");
      fetchAttendance();
      console.log("Updated value:", updatedValue);
    } catch (error) {
      console.error("Error updating total_paid:", error);
    } finally {
      isSavingRef.current = false;
    }
  };

  const isWithinLast10Days = (dateStr: string) => {
    const inputDate = new Date(dateStr);

    const today = new Date();
    today.setHours(0, 0, 0, 0); // Normalize to midnight

    const tenDaysAgo = new Date();
    tenDaysAgo.setDate(today.getDate() - 11);
    tenDaysAgo.setHours(0, 0, 0, 0); // Normalize to midnight

    return inputDate >= tenDaysAgo && inputDate < today;
  };

  interface AttendanceRecord {
    id: number;
    employee_id: number;
    employee_name: string;
    punch_date_time: string;
    is_deleted: number;
    is_manual: number;
  }

  interface AttendanceResponse {
    data?: AttendanceRecord[];
  }

  const fetchAttendanceHistory = async (userId: number, date: string) => {
    setIsLoadingHistory(true);
    const payload = { date };

    try {
      const response: AttendanceResponse = await api(
        `/attendance-listing/${userId}`,
        {
          method: "POST",
          body: payload,
        }
      );

      const attendanceHistory = Array.isArray(response?.data)
        ? response.data
        : [];
      console.log(attendanceHistory);

      if (attendanceHistory.length > 0) {
        const initialPunchDateTime = attendanceHistory[0].punch_date_time;
        const datePart = initialPunchDateTime.split(" ")[0];
        const parsedDate = dayjs(datePart);

        console.log("parsedDate", parsedDate.toString());

        setAttendanceHistory(attendanceHistory);
        setPunchDate(parsedDate); // dayjs object
        setSelectedDate(parsedDate); // dayjs object
      } else {
        setAttendanceHistory([]);
      }
      setIsLoadingHistory(false);
    } catch (error) {
      console.error("Error fetching attendance:", error);
    }
  };

  interface RefreshAttendanceApiResponse {
    success: boolean;
    message: string;
    data: AttendanceItem;
  }

  const handleRefreshRow = async (employeeId: number) => {
    const payload = { id: employeeId };

    try {
      const response: RefreshAttendanceApiResponse = await api(
        `/refresh-attendance`,
        {
          method: "POST",
          body: payload,
        }
      );

      const updatedRecord = response.data;

      if (!updatedRecord) {
        console.warn("No updated data returned");
        return;
      }

      console.log("Updated Record:", updatedRecord);

      // setAttendanceRecords((prevState) =>
      //   prevState.map((employee) =>
      //     employee.id === updatedRecord.id
      //       ? {
      //           ...employee,
      //           in_time: updatedRecord.in_time ?? "",
      //           out_time: updatedRecord.out_time ?? "",
      //           total_mins: updatedRecord.total_mins,
      //           break_mins: updatedRecord.break_mins,
      //           paid_leave: updatedRecord.paid_leave,
      //           paid_holiday_weekoff: updatedRecord.paid_holiday_weekoff,
      //           paid_working: updatedRecord.paid_working,
      //           total_paid: updatedRecord.total_paid,
      //           total_paid_override: updatedRecord.total_paid_override,
      //         }
      //       : employee
      //   )
      // );
          fetchAttendance();
    } catch (error) {
      console.error("Error refreshing attendance:", error);
    }
  };

  const handleHistoryClick = async (userId: number, date: string) => {
    console.log("from history:", userId, date);

    const parsedDate = dayjs(date).startOf("day"); // Force to local midnight

    const validDate = parsedDate.isValid() ? parsedDate : dayjs();

    setSelectedEmployee(userId);
    setPunchDate(validDate);
    setIsModalOpen(true);

    console.log("employee id:", userId);
    console.log("punch date:", validDate.format("DD-MMM-YYYY"));

    setTimeout(() => {
      fetchAttendanceHistory(userId, validDate.format("YYYY-MM-DD"));
    }, 0);
  };

  const handleConfirmIsVerified = (employeeId: number, isVerified: boolean) => {
    console.log("handle confirm for verified", employeeId, isVerified);
    setShowConfirmModal(true);
    setSelectedEmployeeId(employeeId);
    setSelectIsVerified(isVerified);
  };

  const confirmVerified = (employeeId: number | null, isVerified: boolean) => {
    if (employeeId !== null) {
      console.log(`Employee ID: ${employeeId}, Mark Verified: ${isVerified}`);
      onChangeVerified(employeeId, isVerified);
    }
    setShowConfirmModal(false);
  };

  const onChangeVerified = async (employeeId: number, isVerified: boolean) => {
    const payload = {
      id: employeeId,
      is_verified: isVerified ? 1 : 0,
    };

    try {
      const response: AttendanceApiResponse = await api("/verify-attendance", {
        method: "POST",
        body: payload,
      });

      console.log("Success:", response.data);

      fetchAttendance();
    } catch (error) {
      console.error("Error occurred while updating verification:", error);
    }
  };

  const SimpleConfirmModal = ({ isOpen, onClose, onConfirm }: any) => {
    if (!isOpen) return null;
    return (
      <>
        {/* Dimmed Background Overlay */}
        <div
          className="modal-backdrop fade show"
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            zIndex: 1040,
          }}
        ></div>

        <div
          className="modal fade show"
          style={{ display: "block", zIndex: 1050 }}
          aria-labelledby="confirmModalLabel"
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="confirmModalLabel">
                  Confirm Verification
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={onClose}
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body">
                Are you sure you want to verify this attendance record?
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-cancel"
                  onClick={onClose}
                >
                  Close
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={onConfirm}
                >
                  Yes
                </button>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  };

  const columns = [
    ...(hasExpandableRows ? [expandIconColumn] : []),
    serialNumberColumn,
    {
      title: "Name",
      dataIndex: "user_name",
      minWidth: 230,
      maxWidth: 230,
      render: (text: string, record: any) => {
        const maxNameLength = 20;
        const maxDesignationLength = 25;

        const truncateText = (text: string, maxLength: number) =>
          text && text.length > maxLength
            ? text.substring(0, maxLength) + "..."
            : text;

        return (
          <div
            className="d-flex align-items-center file-name-icon"
            onClick={
              userRole === 1
                ? () => handleImageClick(record.user_id, record.user_name)
                : undefined
            }
            style={{ cursor: userRole === 1 ? "pointer" : "default" }}
          >
            <Link to="#" className="avatar avatar-md border avatar-rounded">
              <img
                src={record.image_url || "assets/img/users/default.jpg"}
                className="img-fluid"
                alt="img"
              />
            </Link>
            <div className="ms-2">
              <h6 className="fw-medium" title={record.user_name}>
                <Link to="#">
                  {truncateText(record.user_name, maxNameLength)}
                </Link>
              </h6>
              <span className="fs-12 fw-normal" title={record.designation}>
                {truncateText(record.designation, maxDesignationLength)}
              </span>
            </div>
          </div>
        );
      },
    },
    {
      title: "In/Out",
      dataIndex: "in_out_summary",
      minWidth: 60,
      maxWidth: 60,
      render: (_: any, record: any) => {
        let inOut = "-"; // Default
        if (record.in_out_summary && record.in_out_summary.length > 0) {
          const latestEntry =
            record.in_out_summary[record.in_out_summary.length - 1];
          inOut = latestEntry.out_time ? "Out" : "In";
        }
        return inOut;
      },
    },
    {
      title: "Date",
      dataIndex: "date",
      minWidth: 60,
      maxWidth: 60,
      render: (date: string) => {
        const d = new Date(date);
        const formattedDate = d
          .toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "short",
            year: "numeric",
          })
          .replace(/ /g, "-");
        return formattedDate;
      },
    },
    {
      title: "In Time",
      dataIndex: "in_time",
      minWidth: 100,
      maxWidth: 100,
      render: (time: string) => {
        if (!time) return "-";
        const [hour, minute] = time.split(":");
        const date = new Date();
        date.setHours(Number(hour), Number(minute));
        return date.toLocaleTimeString("en-US", {
          hour: "2-digit",
          minute: "2-digit",
        });
      },
    },
    {
      title: "Out Time",
      dataIndex: "out_time",
      minWidth: 100,
      maxWidth: 100,
      render: (time: string) => {
        if (!time) return "-";
        const [hour, minute] = time.split(":");
        const date = new Date();
        date.setHours(Number(hour), Number(minute));
        return date.toLocaleTimeString("en-US", {
          hour: "2-digit",
          minute: "2-digit",
        });
      },
    },
    {
      title: "Total",
      dataIndex: "total_mins",
      minWidth: 100,
      maxWidth: 100,
      render: (mins: number) => {
        if (mins <= 59) {
          return `${mins} min${mins === 1 ? "" : "s"}`;
        } else {
          const hours = Math.floor(mins / 60);
          const minutes = mins % 60;
          return minutes > 0
            ? `${hours} hr${hours === 1 ? "" : "s"} ${minutes} min${
                minutes === 1 ? "" : "s"
              }`
            : `${hours} hr${hours === 1 ? "" : "s"}`;
        }
      },
    },
    {
      title: "Break",
      dataIndex: "break_mins",
      minWidth: 100,
      maxWidth: 100,
      render: (mins: number) => {
        if (mins <= 59) {
          return `${mins} min${mins === 1 ? "" : "s"}`;
        } else {
          const hours = Math.floor(mins / 60);
          const minutes = mins % 60;
          return minutes > 0
            ? `${hours} hr${hours === 1 ? "" : "s"} ${minutes} min${
                minutes === 1 ? "" : "s"
              }`
            : `${hours} hr${hours === 1 ? "" : "s"}`;
        }
      },
    },
    ...(userRole === 1
      ? [
          {
            title: "L+H+W",
            minWidth: 40,
            maxWidth: 40,
            render: (_: any, record: any) => {
              return `${record.paid_leave}+${record.paid_holiday_weekoff}+${record.paid_working}`;
            },
          },
          {
            title: "Paid",
            dataIndex: "total_paid",
            minWidth: 60,
            maxWidth: 60,
            render: (_: any, employee: any) => {
              const isEditing = editingRowId === employee.id;
              const isToday =
                new Date().toISOString().split("T")[0] === employee.date;

              return isEditing ? (
                <input
                  ref={inputRef}
                  type="number"
                  step="0.5"
                  min="0"
                  max="2"
                  value={editingValue}
                  onChange={(e) => {
                    const value = parseFloat(e.target.value);
                    if (
                      [0, 0.5, 1, 1.5, 2].includes(value) ||
                      e.target.value === ""
                    ) {
                      setEditingValue(e.target.value);
                    }
                  }}
                  onBlur={() => handleSaveUpdatedValue(employee.id)}
                  onKeyDown={(e) => {
                    if (["e", "E", "+", "-"].includes(e.key)) {
                      e.preventDefault();
                    }
                    if (e.key === "Enter") {
                      handleSaveUpdatedValue(employee.id);
                    }
                  }}
                  className="form-control"
                  style={{ width: "60px", display: "inline-block" }}
                  autoFocus
                />
              ) : (
                <>
                  {employee.total_paid !== employee.total_paid_override ? (
                    <>
                      <del style={{ color: "red" }}>{employee.total_paid}</del>{" "}
                      <span>{employee.total_paid_override}</span>
                    </>
                  ) : (
                    <>{employee.total_paid}</>
                  )}
                  {userRole === 1 &&
                    loggedInUserId !== employee.user_id.toString() &&
                    !isToday &&
                    isWithinLast10Days(employee.date) && (
                      <i
                        className="fas fa-pencil-alt"
                        onClick={() =>
                          enableEditing(
                            employee.id,
                            employee.total_paid_override ?? employee.total_paid
                          )
                        }
                        style={{
                          cursor: "pointer",
                          marginLeft: "5px",
                          color: "blue",
                        }}
                        title="Edit"
                      />
                    )}
                </>
              );
            },
          },
          {
            title: "Action",
            dataIndex: "action",
            minWidth: 90,
            maxWidth: 90,
            render: (_text: string, record: any) => {
              const today = new Date().toISOString().split("T")[0];
              const canVerify =
                record.is_verified !== 1 &&
                loggedInUserId !== record.user_id.toString() &&
                record.date !== today &&
                isWithinLast10Days(record.date);

              const canResync =
                isWithinLast10Days(record.date) &&
                record.date !== today &&
                loggedInUserId !== record.user_id.toString();

              return (
                <div className="action-icon d-inline-flex align-items-center">
                  {/* History Button */}
                  <button
                    type="button"
                    title="History"
                    className="btn btn-icon btn-sm me-2"
                    onClick={() =>
                      handleHistoryClick(record.user_id, record.date)
                    }
                  >
                    <i className="fa fa-info-circle" />
                  </button>

                  {/* Conditional Verify Button */}
                  {canVerify ? (
                    <button
                      className="btn btn-icon"
                      title="Verify"
                      onClick={() =>
                        handleConfirmIsVerified(record.id, !record.is_verified)
                      }
                    >
                      <i
                        className="fas fa-check"
                        style={{ fontSize: "19px", cursor: "pointer" }}
                      />
                    </button>
                  ) : (
                    <span className="empty-space-refresh"></span>
                  )}

                  {/* Conditional Resync Button */}
                  {canResync ? (
                    <button
                      className="btn btn-icon"
                      title="Resync"
                      onClick={() => handleRefreshRow(record.id)}
                    >
                      <i className="fa-solid fa-rotate-right"></i>
                    </button>
                  ) : (
                    <span className="empty-space-refresh"></span>
                  )}
                </div>
              );
            },
          },
        ]
      : []),
  ];

  const expandable = {
    expandedRowRender: (record: AttendanceItem) => (
      <table
        style={{
          width: "100%",
          background: "#F9F9F9",
          tableLayout: "fixed", //enforce fixed layout
          minWidth: 800,
        }}
      >
        <colgroup>
          <col style={{ minWidth: "30px", maxWidth: "30px" }} />{" "}
          {/* expand icon */}
          <col style={{ minWidth: "30px", maxWidth: "30px" }} /> {/* serial */}
          <col style={{ minWidth: "230px", maxWidth: "230px" }} /> {/* name */}
          <col style={{ minWidth: "60px", maxWidth: "60px" }} /> {/* In/Out */}
          <col style={{ minWidth: "60px", maxWidth: "60px" }} /> {/* date */}
          <col style={{ minWidth: "100px", maxWidth: "100px" }} />{" "}
          {/* In Time */}
          <col style={{ minWidth: "100px", maxWidth: "100px" }} />{" "}
          {/* Out Time */}
          <col style={{ minWidth: "100px", maxWidth: "100px" }} /> {/* Total */}
          <col style={{ minWidth: "100px", maxWidth: "100px" }} /> {/* Break */}
          {userRole === 1 && (
            <>
              <col style={{ minWidth: "40px", maxWidth: "40px" }} />{" "}
              {/* L+H+W */}
              <col style={{ minWidth: "60px", maxWidth: "60px" }} />{" "}
              {/* Paid */}
              <col style={{ minWidth: "90px", maxWidth: "90px" }} />{" "}
              {/* Action */}
            </>
          )}
        </colgroup>

        <tbody>
          {record.in_out_summary?.map((summary, idx) => (
            <tr key={idx}>
              <td />
              <td />
              <td />
              <td />
              <td />
              <td>{convertToAMPM(summary.in_time)}</td>
              <td>
                {summary.out_time ? convertToAMPM(summary.out_time) : "-"}
              </td>
              <td>{formatTotalMinutes(summary.total_minutes)}</td>
              <td />
              {userRole === 1 && (
                <>
                  <td /> {/* L+H+W */}
                  <td /> {/* Paid */}
                  <td /> {/* Action */}
                </>
              )}
            </tr>
          ))}
        </tbody>
      </table>
    ),
    rowExpandable: (record: any) => record.in_out_summary?.length > 0,
    expandedRowKeys,
    onExpand: tableOnExpand,
    expandIconColumnIndex: -1,
  };

  function isToday(date: string): boolean {
    const today = new Date().toISOString().split("T")[0]; // 'YYYY-MM-DD'
    return date === today;
  }

  interface AttendanceFilterParams {
    selectedUserId: string | null;
    isLOPChecked: boolean;
    isVerifiedChecked: boolean;
    selectedStartDate: string; // 'YYYY-MM-DD'
    selectedEndDate: string; // 'YYYY-MM-DD'
    attendanceErrorMessage?: string;
    currentPage?: number;
  }

  useEffect(() => {
    if (encryptedQuery && users.length) {
      try {
        const decoded = decodeURIComponent(encryptedQuery);
        const result = decryptQuery(decoded);

        if (result && typeof result === "object") {
          const data = result as AttendanceFilterParams;

          const userExists = users.some(
              (emp) => emp.value === data.selectedUserId
          );
          setSelectedUserId(userExists ? data.selectedUserId : "all");
          setIsLOPChecked(!!data.isLOPChecked);
          setIsVerifiedChecked(!!data.isVerifiedChecked);
          setSelectedStartDate(data.selectedStartDate);
          setSelectedEndDate(data.selectedEndDate);
          setCurrentPage(data.currentPage ?? 1);
          setAttendanceErrorMessage(data.attendanceErrorMessage ?? "");
          return;
        }
      } catch (e) {
        console.warn("Failed to decrypt attendance query:", e);
      }
    }
    if (!encryptedQuery) {
    const saved = localStorage.getItem("attendanceFilters");
    if (saved) {
      navigate(`/attendance-view/A/${encodeURIComponent(saved)}`, { replace: true });
    }
  }

    // Fallback if no encrypted query or decryption fails
    const today = moment().format("YYYY-MM-DD");
    setSelectedUserId("all");
    setIsLOPChecked(false);
    setIsVerifiedChecked(false);
    setSelectedStartDate(today);
    setSelectedEndDate(today);
  }, [encryptedQuery,users,navigate]);

  const updateFilterUrl = (
    filters: AttendanceFilterParams,
    baseRoute: string = "/attendance-view/A"
  ) => {
    if (areFiltersDefault(filters)) {
      // Navigate to base URL if filters are default
      navigate(baseRoute, { replace: false });
      localStorage.removeItem("attendanceFilters");
    } else {
      const encrypted = encryptQuery(filters);
      localStorage.setItem("attendanceFilters", encrypted);
      const encoded = encodeURIComponent(encrypted);
      navigate(`${baseRoute}/${encoded}`, { replace: false });
    }
  };

  const handlePageChange = (page: number) => {
    setCurrentPage(page);

    updateFilterUrl({
      selectedUserId,
      isLOPChecked,
      isVerifiedChecked,
      selectedStartDate,
      selectedEndDate,
      currentPage: page,
      attendanceErrorMessage: attendanceErrorMessage || "",
    });
  };

  const handleUserChange = (userId: string | null) => {
    setAttendanceErrorMessage(""); // Reset the error
    setSelectedUserId(userId);
    updateFilterUrl({
      selectedUserId: userId,
      isLOPChecked,
      isVerifiedChecked,
      selectedStartDate,
      selectedEndDate,
    });
  };

  const onToggleLOPFilter = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.checked;
    setAttendanceErrorMessage(""); // Reset the error
    setIsLOPChecked(value);
    updateFilterUrl({
      selectedUserId,
      isLOPChecked: value,
      isVerifiedChecked,
      selectedStartDate,
      selectedEndDate,
    });
  };

  const onToggleVerifiedFilter = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.checked;
    setAttendanceErrorMessage(""); // Reset the error
    setIsVerifiedChecked(value);
    updateFilterUrl({
      selectedUserId,
      isLOPChecked,
      isVerifiedChecked: value,
      selectedStartDate,
      selectedEndDate,
    });
  };

  const handleDateRangeChangeFilter = (startDate: string, endDate: string) => {
    setAttendanceErrorMessage(""); // Reset the error
    setSelectedStartDate(startDate);
    setSelectedEndDate(endDate);

    updateFilterUrl({
      selectedUserId,
      isLOPChecked,
      isVerifiedChecked,
      selectedStartDate: startDate,
      selectedEndDate: endDate,
    });
  };

  interface Employee {
    id: number;
    in_time: string | null;
    out_time: string | null;
    total_mins: number;
    break_mins: number;
    paid_leave: number;
    paid_holiday_weekoff: number;
    paid_working: number;
    total_paid: number;
    total_paid_override: number;
    user_id: number;
    is_verified: number;
    date: string;
  }

  interface AttendanceItem {
    id: number;
    user_id: number;
    date: string;
    paid_leave: number;
    paid_holiday_weekoff: number;
    paid_working: number;
    total_paid: number;
    total_paid_override: number;
    is_verified: number;
    remark: string;
    created_at: string;
    updated_at: string;
    work_mins: number;
    break_mins: number;
    leave_mins: number;
    total_mins: number;
    in_time: string;
    out_time: string;
    verified_by: number | null;
    verified_date: string | null;
    user_name: string;
    emp_photo: string | null;
    designation: string;
    verified_by_name: string | null;
    image_url: string;
    in_out_summary: {
      in_time?: string;
      out_time?: string;
      total_minutes?: number;
    }[];
  }

  type AttendanceApiResponse = {
    status?: string;
    data?: {
      current_page: number;
      data: AttendanceItem[];
      first_page_url: string;
      from: number;
      last_page: number;
      last_page_url: string;
      links: {
        url: string | null;
        label: string;
        active: boolean;
      }[];
      next_page_url: string | null;
      path: string;
      per_page: number;
      prev_page_url: string | null;
      to: number;
      total: number;
    };
    today_hours?: string;
    total_mins?: string;
    break_mins?: string;
    unverifiedrecord?: number;
    attendance_error_count?: number;
  };

  const fetchAttendance = async (fromDate?: string, toDate?: string) => {
    const usedFrom = fromDate ?? selectedStartDate;
    const usedTo = toDate ?? selectedEndDate;

    if (!usedFrom || !usedTo) return;
    const thisRequestId = ++latestRequestIdRef.current;

    console.log("Calling API with:", usedFrom, usedTo);
    console.log("API has id:", selectedUserId);
    console.log("API has error:", attendanceErrorMessage);
    console.log("API has lop,ver:", isLOPChecked, isVerifiedChecked);

    // if (!employeeId) return;

    const payload = {
      lop: isLOPChecked ? 1 : "",
      verified: isVerifiedChecked ? 1 : "",
      employeeId: selectedUserId === "all" ? null : selectedUserId,
      fromDate: usedFrom,
      toDate: usedTo,
      error: attendanceErrorMessage || "",
      currentPage,
      pageSize,
    };

    try {
      setLoading(true);
      const response: AttendanceApiResponse = await api(
        "/show-attendance-for-calender",
        {
          method: "POST",
          body: payload,
        }
      );

    // Only apply the response if it's the latest request
    if (thisRequestId === latestRequestIdRef.current) {
      const records = response.data?.data || [];
      setAttendanceRecords(records);
      setTotalItems(response.data?.total ?? 0);
      setTodayHours(response.today_hours || "00:00");
      setTotalUnverifiedrecord(response.unverifiedrecord ?? 0);
      setErrorCount(response.attendance_error_count ?? 0);
      setTotalMinute(response.total_mins || "00:00");
      setTotalBreakminute(response.break_mins || "00:00");
    }
    } catch (err) {
      if (err instanceof Error) {
        console.error("Failed to fetch attendance:", err.message);
      } else {
        console.error("Unknown error while fetching attendance");
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const storedUser = JSON.parse(localStorage.getItem("user") || "{}");
    const loggedInUserId = String(storedUser?.id);
    const role = storedUser?.role_name;
    setLoggedInUserId(loggedInUserId);
    setUserRole(role);
  }, []); // run once on mount

  useEffect(() => {
  const employees = filtersData?.employees || [];
  if (employees.length > 0) {
    const formatted: Option[] = employees.map((u: any) => ({
      value: String(u.id),
      label: u.name,
      image_url: u.image_url,
    }));

    const allOption: Option = { value: "all", label: "All", image_url: "" };
    const withAllOption: Option[] = [allOption, ...formatted];

    setUsers(withAllOption);
    setSelectedUserId("all");  

    if (filtersData?.reporting_head_flag !== undefined) {
      setIsReportingHead(filtersData.reporting_head_flag);
    }
  }
}, [filtersData]);

  const handleReset = () => {
    setSelectedUserId("all");
    setIsLOPChecked(false);
    setIsVerifiedChecked(false);
    setSelectedStartDate(today);
    setSelectedEndDate(today);
    setCurrentPage(1);

    localStorage.removeItem("attendanceFilters");

    navigate(`/attendance-view/A`, { replace: false });
  };

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 1054);
    handleResize(); // run once on mount
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const isResetVisible =
      (selectedUserId && String(selectedUserId) !== "all") ||
      selectedStartDate !== today ||
      selectedEndDate !== today ||
      isLOPChecked ||
      isVerifiedChecked;

    const showLOP = userRole === 1;
    const showVerified = userRole === 1;
    const showDatePicker = userRole === 1 || userRole === 2;
    const showUserSelect =
      userRole === 1 || (userRole === 2 && isReportingHead);

    const FiltersDesktop = () => (
      <div className="px-2 px-md-2">
        <div className="attendance-filters d-flex align-items-center flex-wrap">
          <div
            className="d-flex align-items-center border bg-white rounded p-1 icon-list"
            style={{ left: sidebarWidth, position: "absolute" }}
          >
            <Link
              to="/attendance-view/A"
              className="btn btn-icon btn-sm me-1 active bg-primary text-white"
            >
              <i className="ti ti-list-details" />
            </Link>
            <Link to="/attendance-view/C" className="btn btn-icon btn-sm">
              <i className="ti ti-calendar-event" />
            </Link>
          </div>

          <div className="d-flex align-items-center gap-2">
            {isResetVisible && (
              <button
                className="btn add_btn_size btn-outline-primary att-reset"
                onClick={handleReset}
                title="Reset"
              >
                <i className="ti ti-refresh" />
              </button>
            )}
            {showLOP && (
              <div className="form-check form-check-md d-flex align-items-center att-checkbox">
                <input
                  className="form-check-input"
                  type="checkbox"
                  checked={isLOPChecked}
                  onChange={onToggleLOPFilter}
                  id="checkebox-LOP"
                />
                <label className="form-check-label" htmlFor="checkebox-LOP">
                  LOP
                </label>
              </div>
            )}
            {showVerified && (
              <div className="form-check form-check-md d-flex align-items-center att-checkbox">
                <input
                  className="form-check-input"
                  type="checkbox"
                  checked={isVerifiedChecked}
                  onChange={onToggleVerifiedFilter}
                  id="checkebox-Verified"
                />
                <label
                  className="form-check-label"
                  htmlFor="checkebox-Verified"
                >
                  Verified
                </label>
              </div>
            )}
            {showDatePicker && (
              <div
                className={`input-icon-end position-relative ${
                  userRole === 2 && !isReportingHead
                    ? "custom-datepicker-employee"
                    : "custom-datepicker"
                }`}
              >
                <PredefinedDateRanges
                  startDate={selectedStartDate}
                  endDate={selectedEndDate}
                  onDateRangeChange={handleDateRangeChangeFilter}
                />
                <span className="input-icon-addon">
                  <i className="ti ti-chevron-down" />
                </span>
              </div>
            )}
            {showUserSelect && (
              <CommonSelect
                className="select att-select"
                options={users}
                value={users.find((u) => u.value === selectedUserId) || null}
                onChange={(selectedOption: any) => {
                  handleUserChange(selectedOption?.value || null);
                }}
              />
            )}
          </div>
        </div>
      </div>
    );

    const FiltersMobile = () => {
      const [showModal, setShowModal] = useState(false);
      const modalRef = useRef<HTMLDivElement | null>(null);

      // Close modal on outside click
      useEffect(() => {
        console.log("showmodal:",showModal)
        const handleClickOutside = (event: MouseEvent) => {
          if (
            modalRef.current &&
            !modalRef.current.contains(event.target as Node)
          ) {
            setShowModal(false);
          }
        };

        if (showModal) {
          document.addEventListener("mousedown", handleClickOutside);
        }

        return () => {
          document.removeEventListener("mousedown", handleClickOutside);
        };
      }, [showModal]);

      return (
        <div className="holiday-full-width">
          <div className="attendance-filters-mobile d-flex align-items-center justify-content-between">
            {/* View toggle */}
            <div className="d-flex align-items-center border bg-white rounded p-1 icon-list toggle-att-mobile">
              <Link
                to="/attendance-view/A"
                className="btn btn-icon btn-sm me-1 active bg-primary text-white"
              >
                <i className="ti ti-list-details" />
              </Link>
              <Link to="/attendance-view/C" className="btn btn-icon btn-sm">
                <i className="ti ti-calendar-event" />
              </Link>
            </div>

            {/* Reset + Datepicker */}
            <div className="d-flex align-items-center gap-1">
              {isResetVisible && (
                <button
                  className="btn add_btn_size btn-outline-primary att-add-margin-right"
                  onClick={handleReset}
                  title="Reset"
                >
                  <i className="ti ti-refresh" />
                </button>
              )}
              {showDatePicker && (
                <div
            className="holiday-flex"
            style={{
              position:isMobile?"absolute":"static",
              right: isMobile?"10px":"0",
              left: isResetVisible&&isMobile ? "128px" : "88px",
            }}
          >
                <div
                  className={`input-icon-end position-relative ${
                    userRole === 2 && !isReportingHead
                      ? "custom-datepicker-employee"
                      : "custom-datepicker"
                  }`} style={{marginRight:isMobile?"44px":'0'}}
                >
                  <PredefinedDateRanges
                    startDate={selectedStartDate}
                    endDate={selectedEndDate}
                    onDateRangeChange={handleDateRangeChangeFilter}
                  />
                  <span className="input-icon-addon">
                    <i className="ti ti-chevron-down" />
                  </span>
                </div>
                </div>
              )}
            </div>
            

            {/* Filter Modal Trigger */}
            {!(userRole === 2 && !isReportingHead) && (
              <button
                className="btn btn-outline-primary add_btn_size z-index-filter"
                onClick={() => {
                  console.log("Filter icon clicked");
                  setShowModal(true);
                }}
                style={{marginLeft:"6px",marginRight:"7px"}}
              >
                <i className="ti ti-filter" />
              </button>
            )}
          </div>

          {/* Modal */}
          {showModal && (
            <div
              className="modal-backdrop"
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100vw",
                height: "100vh",
                backgroundColor: "rgba(0,0,0,0.3)",
                display: "flex",
                justifyContent: "center",
                alignItems: "flex-start",
                paddingTop: "103px",
                zIndex: 1050,
              }}
            >
              <div
                ref={modalRef}
                className="bg-white p-3 rounded shadow"
                style={{ width: "90%", maxWidth: "400px" }}
              >
                {/* LOP */}
                {showLOP && (
                  <div className="form-check form-check-md d-flex align-items-center mb-2">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      checked={isLOPChecked}
                      onChange={onToggleLOPFilter}
                      id="modal-check-LOP"
                    />
                    <label
                      className="form-check-label ms-2"
                      htmlFor="modal-check-LOP"
                    >
                      LOP
                    </label>
                  </div>
                )}

                {/* Verified */}
                {showVerified && (
                  <div className="form-check form-check-md d-flex align-items-center mb-2">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      checked={isVerifiedChecked}
                      onChange={onToggleVerifiedFilter}
                      id="modal-check-verified"
                    />
                    <label
                      className="form-check-label ms-2"
                      htmlFor="modal-check-verified"
                    >
                      Verified
                    </label>
                  </div>
                )}

                {/* User Select */}
                {showUserSelect && (
                  <CommonSelect
                    className="select mt-2"
                    options={users}
                    value={
                      users.find((u) => u.value === selectedUserId) || null
                    }
                    onChange={(selectedOption: any) => {
                      handleUserChange(selectedOption?.value || null);
                    }}
                  />
                )}
              </div>
            </div>
          )}
        </div>
      );
    };

    setFilters(isMobileView ? <FiltersMobile /> : <FiltersDesktop />);

    return () => setFilters(null);
  }, [
    isMobile,
    isMobileView,
    setFilters,
    users,
    userRole,
    isReportingHead,
    selectedUserId,
    selectedStartDate,
    selectedEndDate,
    isLOPChecked,
    isVerifiedChecked,
  ]);

  const getModalContainer = () => {
    const modalElement = document.getElementById("modal-datepicker");
    return modalElement ? modalElement : document.body;
  };

  const stats = [
    { title: "Today", value: TodayHours },
    { title: "Total", value: TotalMinute },
    { title: "Break", value: TotalBreakminute },
    ...(userRole === 1
      ? [
          {
            title: "Unverified",
            value: TotalUnverifiedrecord,
            onClick: handleErrorClick,
          },
          { title: "Errors", value: errorCount, onClick: handleErrorsClick, },
        ]
      : []),
  ];

  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          {/* Cards Section */}
          <div className="row custom-att-boxes">
            {stats.map((item, index) => (
              <div key={index}>
                <div className="card flex-fill att-card">
                  <div className="card-body d-flex align-items-center justify-content-between box-padding boxes-att-mobile">
                    <div className="d-flex align-items-center overflow-hidden">
                      <div
                        onClick={item.onClick}
                        style={{ cursor: item.onClick ? "pointer" : "default" }}
                      >
                        <p
                          className={`fs-16 mb-1 text-truncate att-boxes-title ${
                            item.title === "Unverified"
                              ? "att-title-ellipsis"
                              : item.title === "Today" ||
                                item.title === "Errors"
                              ? "att-today-ellipsis"
                              : ""
                          }`}
                        >
                          {item.title}
                        </p>
                        <h3 className="mb-0 att-boxes-value">{item.value}</h3>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Table Section */}
          <div className="card card-margin-bottom">
            <div className="card-body p-0" style={{ minHeight: tableHeight, display: "flex", flexDirection: "column" }}>
              <Table
                style={{ flex: 1 }}
                dataSource={attendanceRecords}
                columns={columns}
                totalItems={totalItems}
                pageSize={pageSize}
                loading={loading}
                rowClassName={(record) => {
                  const isOverride = record.total_paid_override !== 1;
                  const isNotToday = !isToday(record.date);
                  return isOverride && isNotToday ? "light-red-row" : "";
                }}
                expandable={expandable}
                rowKey={(record) => record.id}
                currentPage={currentPage}
                onPageChange={handlePageChange}
                // style={{ tableLayout: "fixed" }} // important
              />
            </div>
          </div>
        </div>

        {/* Footer */}
        <div>
          <Footer />
        </div>
      </div>

      {/* Attendance History Modal */}
      <div
        className="modal fade"
        id="staticBackdrop"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabIndex={-1}
        aria-labelledby="staticBackdropLabel"
        aria-hidden="true"
        ref={modalRef}
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content custom-modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="staticBackdropLabel">
                Attendance History
              </h5>
              <button
                id="hiddenCloseBtn"
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => {
                  resetForm();
                }}
              />
            </div>
            <div className="modal-body custom-modal-body">
              <div className="table-container">
                <div className="table-responsive fixed-header-table">
                  <table className="table table-hover table-striped table-vcenter text-nowrap mb-0">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Type</th>
                        <th>Date Time</th>
                        <th>Deleted</th>
                      </tr>
                    </thead>
                    <tbody>
                      {isLoadingHistory ? (
                        <tr>
                          <td colSpan={4} className="text-center">
                            Loading...
                          </td>
                        </tr>
                      ) : (
                        <>
                          {Array.isArray(attendanceHistory) &&
                          attendanceHistory.length > 0 ? (
                            attendanceHistory.map((employee) => {
                              const isDeleted = employee.is_deleted === 1;
                              const visibleEmployees = attendanceHistory.filter(
                                (emp) => emp.is_deleted !== 1
                              );
                              const rowIndex = visibleEmployees.findIndex(
                                (emp) => emp.id === employee.id
                              );

                              return (
                                <tr
                                  key={employee.employee_id}
                                  className={isDeleted ? "striked-row" : ""}
                                >
                                  <td>{!isDeleted ? rowIndex + 1 : ""}</td>
                                  <td>
                                    {!isDeleted
                                      ? (rowIndex + 1) % 2 === 0
                                        ? "OUT"
                                        : "IN"
                                      : ""}
                                  </td>
                                  <td>
                                    {formatDate(
                                      employee.punch_date_time.split(" ")[0]
                                    )}{" "}
                                    {formatAttTime(
                                      employee.punch_date_time.split(" ")[1]
                                    )}
                                    {employee.is_manual === 1
                                      ? " (manual)"
                                      : ""}
                                  </td>
                                  <td>
                                    {/* <input
                            type="checkbox"
                            checked={isDeleted}
                            className="big-checkbox"
                            onClick={() => handleCheckboxClick(employee.id, !isDeleted)}
                          /> */}
                                    <div className="form-check form-check-md">
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        checked={isDeleted}
                                        onClick={() =>
                                          handleCheckboxClick(
                                            employee.id,
                                            !isDeleted
                                          )
                                        }
                                        id="checkebox-del"
                                      />
                                    </div>
                                  </td>
                                </tr>
                              );
                            })
                          ) : (
                            <tr>
                              <td colSpan={4} className="text-center">
                                Empty.
                              </td>
                            </tr>
                          )}

                          {/* New Record Input Row */}
                          <tr>
                            <td>{""}</td>
                            <td>{""}</td>
                            <td>
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                <div className="input-icon-end position-relative att-datepicker">
                                  <DatePicker
                                    className="form-control datetimepicker att-ant-picker"
                                    format={{
                                      format: "DD-MMM-YYYY",
                                      type: "mask",
                                    }}
                                    getPopupContainer={getModalContainer}
                                    placeholder="DD-MMM-YYYY"
                                    value={punchDate}
                                    onChange={(date) => setPunchDate(date)}
                                  />
                                  <span className="input-icon-addon">
                                    <i className="ti ti-calendar text-gray-7" />
                                  </span>
                                </div>
                                <input
                                  type="number"
                                  className="time"
                                  min="1"
                                  max="12"
                                  value={hour}
                                  placeholder="HH"
                                  onChange={handleHourChange}
                                  style={{ width: "50px", margin: "0 2px" }}
                                  onKeyDown={(e) =>
                                    ["e", "E", "+", "-"].includes(e.key) &&
                                    e.preventDefault()
                                  }
                                />
                                :
                                <input
                                  type="number"
                                  className="time"
                                  min="0"
                                  max="59"
                                  value={minute}
                                  placeholder="MM"
                                  onChange={handleMinuteChange}
                                  style={{ width: "50px", margin: "0 2px" }}
                                  onKeyDown={(e) =>
                                    ["e", "E", "+", "-"].includes(e.key) &&
                                    e.preventDefault()
                                  }
                                />
                                :
                                <input
                                  type="number"
                                  className="time"
                                  min="0"
                                  max="59"
                                  value={second}
                                  placeholder="SS"
                                  onChange={handleSecondChange}
                                  style={{ width: "50px", margin: "0 2px" }}
                                  onKeyDown={(e) =>
                                    ["e", "E", "+", "-"].includes(e.key) &&
                                    e.preventDefault()
                                  }
                                />
                                <select
                                  value={ampm}
                                  onChange={(e) => setAMPM(e.target.value)}
                                  style={{ marginLeft: "5px", height: "27px" }}
                                >
                                  <option value="AM">AM</option>
                                  <option value="PM">PM</option>
                                </select>
                                <button
                                  type="button"
                                  className="btn-save-att btn-primary add-button-att"
                                  onClick={handleSaveClick}
                                >
                                  Save
                                </button>
                              </div>
                            </td>
                            <td>{""}</td>
                          </tr>
                        </>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>

              {/* Dimmed Background Overlay */}
              {showDeleteConfirmModal && (
                <div
                  className="modal-backdrop fade show"
                  style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: "rgba(0, 0, 0, 0.5)", // Dimmed background
                    zIndex: 1040,
                  }}
                ></div>
              )}

              {showDeleteConfirmModal && (
                <div
                  className="modal fade show"
                  style={{ display: "block", zIndex: 1050 }}
                  aria-labelledby="deleteConfirmModalLabel"
                >
                  <div className="modal-dialog">
                    <div className="modal-content">
                      <div className="modal-header">
                        <h5
                          className="modal-title"
                          id="deleteConfirmModalLabel"
                        >
                          Confirm{" "}
                          {selectedIsDeleted ? "Deletion" : "Restoration"}
                        </h5>
                        <button
                          type="button"
                          className="btn-close"
                          onClick={handleCancel}
                          aria-label="Close"
                        ></button>
                      </div>
                      <div className="modal-body">
                        Are you sure you want to{" "}
                        {selectedIsDeleted ? "delete" : "restore"} this record?
                      </div>
                      <div className="modal-footer">
                        <button
                          type="button"
                          className="btn btn-cancel"
                          data-bs-dismiss="modal"
                          onClick={handleCancel}
                        >
                          Close
                        </button>
                        <button
                          type="button"
                          className="btn btn-primary"
                          onClick={() => {
                            handleDelete(selectedEmployeeId, selectedIsDeleted);
                          }}
                        >
                          Yes
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-cancel"
                data-bs-dismiss="modal"
                onClick={() => {
                  resetForm();
                }}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>

      <SimpleConfirmModal
        isOpen={showConfirmModal}
        onClose={() => setShowConfirmModal(false)}
        onConfirm={() =>
          confirmVerified(selectedEmployeeId, selectedIsVerified)
        }
      />
      <ToastContainer position="top-right" autoClose={3000} />
    </>
  );
};

export default AttendanceList;
